import { action, observable, computed, makeAutoObservable } from 'mobx';

const observerOptions: IntersectionObserverInit = {
    root: null,
    rootMargin: '100px',
    threshold: 0.15,
};
export class LazyLoadingImgState {
    private readonly observer: IntersectionObserver | null = null;
    @observable public imgRef: HTMLImageElement | null = null;

    @observable private allowLoad: boolean = false;
    @observable public allowShow: boolean = false;

    public constructor(
        private readonly imgSrc: string,
        isBrowser: boolean
    ) {
        if (isBrowser) {
            this.observer = new IntersectionObserver(this.handleObserveImage, observerOptions);
        }
        makeAutoObservable(this);
    }

    public setImgRef = (ref: HTMLImageElement | null): void => {
        this.imgRef = ref;
    };

    @action private handleObserveImage = (entries: IntersectionObserverEntry[]): void => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0 && this.imgRef !== null) {
                this.allowLoad = true;
                this.observer?.unobserve(entry.target);
            }
        });
    };

    public onLoad = (): void => {
        this.allowShow = true;
    };

    public unobserve = (): void => {
        if (this.observer !== null) {
            this.observer.disconnect();
        }
    };

    public observe = (): void => {
        if (this.imgRef !== null && this.observer !== null) {
            this.observer.observe(this.imgRef);
        }
    };

    @computed public get imgForView(): string | undefined {
        if (this.allowLoad) {
            return this.imgSrc;
        }

        return undefined;
    }
}
